import {useCallback} from 'react';

import {usePropsSelector} from '../../../../state/hooks';
import {makeHasPanelsSelector} from '../../../../state/views/panelBankConfig/selectors';
import {useWorkspaceRefsContext} from '../../../Workspace/WorkspaceRefsContext';
import type {AddPanelsMenuItemProps} from '../types';

export const useIsItemRecommended = () => {
  const {panelBankConfigRef} = useWorkspaceRefsContext();
  const hasPanels = usePropsSelector(makeHasPanelsSelector, panelBankConfigRef);
  return useCallback(
    (item: AddPanelsMenuItemProps) => {
      return item.type === 'quick-add' && !hasPanels;
    },
    [hasPanels]
  );
};
